import { render, staticRenderFns } from "./GroupsHeaders.vue?vue&type=template&id=387d636b&scoped=true&"
import script from "./GroupsHeaders.vue?vue&type=script&lang=js&"
export * from "./GroupsHeaders.vue?vue&type=script&lang=js&"
import style0 from "./GroupsHeaders.vue?vue&type=style&index=0&id=387d636b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d636b",
  null
  
)

export default component.exports